import { Grid } from "@mui/material";
import CustomSelect from "../../../../../../../../components/CustomSelect";
import Input from "../../../../../../../../components/Input";
import { PatientVital } from "../../../../../../../../services";
import {
  FLAG_OPTS,
  LUNCH_TYPE_OPTS,
  MEAL_OPTS,
  VitalFormik,
} from "../vital-constant";

interface GlucoseFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const GlucoseFields = ({ formik, ind }: GlucoseFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  const selectHandleChange = (k: keyof PatientVital, v: string | null) => {
    formik.setFieldValue(getKey(k), v);
  };

  return (
    <Grid
      container
      sx={{
        gap: 2,
      }}
      size={12}
    >
      <Grid size={2.6}>
        <Input
          label="Mg/dL"
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            placeholder: "e.g. 100 (mg/dL)",
          }}
        />
      </Grid>
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("method")}
          placeholder="Before Meal"
          options={MEAL_OPTS}
          value={activeVital?.method}
          onChange={(v) => selectHandleChange("method", v)}
        />
      </Grid>
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("type")}
          placeholder="BreakFast"
          options={LUNCH_TYPE_OPTS}
          value={activeVital?.type}
          onChange={(v) => selectHandleChange("type", v)}
        />
      </Grid>
      <Grid size={1.8}>
        <CustomSelect
          name={getKey("flag")}
          placeholder="Flag"
          options={FLAG_OPTS}
          value={activeVital?.flag}
          onChange={(v) => selectHandleChange("flag", v)}
        />
      </Grid>
    </Grid>
  );
};

export default GlucoseFields;
